export default __webpack_public_path__ + "static/media/Positions.5f3d4cdb.svg";